import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import PayProviderInvoicesForm from "@components/dynamic/PayProviderInvoicesForm";

const PayProviderInvoicesIndex = () => {
  useEffect(() => {
  }, []);


  return (
    <PageContainer
      title="Cancelar Facturas Provedor"
      backUrl="/user/dashboard-accounting"
    >
      <PayProviderInvoicesForm />
    </PageContainer >
  );
}

export default PayProviderInvoicesIndex;
